import React, { Component } from 'react';
import ErrorReportingTool from './../../common/ErrorReportingTool';
import {GA4Common, GA_EVENT} from "../../common/GA4Common";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorInfo: {}
    };
  }

  componentDidCatch(error, info) {
    this.setState({
      hasError: true,
      errorInfo: info
    });
    ErrorReportingTool.reportReactLifeCycle(info, error.stack);
    GA4Common.sendEventGA(GA_EVENT.PAGE_VIEW, {errorMessage: error+info.componentStack})
  }

  render() {
    if(this.state.hasError){      
      return <div>{this.state.errorInfo}</div>
    }
    return this.props.children;
  }
}

export default ErrorBoundary


// WEBPACK FOOTER //
// ./src/app/components/ErrorBoundary/index.js